import type { Locale } from '@gonka-wallet/storage';

export type ResolvedLocale = Exclude<Locale, 'system'>;

export interface DetectInput {
  explicit: Locale;
  tmaLanguageCode: string | undefined;
  browserLanguages: readonly string[];
  /** navigator.language fallback when browserLanguages is empty or no match */
  singleLanguage?: string;
}

const SUPPORTED: ResolvedLocale[] = ['en', 'ru', 'zh'];

function normalizeLocaleCode(code: string): ResolvedLocale | null {
  const lower = code.toLowerCase();
  if (lower.startsWith('ru')) return 'ru';
  if (lower.startsWith('zh')) return 'zh';
  if (lower.startsWith('en')) return 'en';
  return null;
}

export function detectInitialLocale(input: DetectInput): ResolvedLocale {
  if (input.explicit !== 'system' && SUPPORTED.includes(input.explicit as ResolvedLocale)) {
    return input.explicit as ResolvedLocale;
  }
  if (input.tmaLanguageCode) {
    const match = normalizeLocaleCode(input.tmaLanguageCode);
    if (match) return match;
  }
  for (const lang of input.browserLanguages) {
    const match = normalizeLocaleCode(lang);
    if (match) return match;
  }
  if (input.singleLanguage) {
    const match = normalizeLocaleCode(input.singleLanguage);
    if (match) return match;
  }
  return 'en';
}
